import React from 'react';
import { motion } from 'framer-motion';

function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className = '',
  compact = false,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`empty-state-panel flex flex-col items-center text-center ${compact ? 'px-4 py-8' : 'px-6 py-12'} ${className}`}
    >
      {Icon && (
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.08, type: 'spring', stiffness: 320, damping: 22 }}
          className="relative mb-5"
        >
          <div className="absolute inset-0 scale-150 animate-pulse rounded-full bg-orange-200/30 blur-2xl " />
          <div className="icon-tile relative mx-auto h-16 w-16 from-orange-400 to-amber-500 shadow-glow ring-4 ring-orange-100/60">
            <Icon className="h-8 w-8 text-white" strokeWidth={1.5} />
          </div>
        </motion.div>
      )}
      <motion.h3
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.12 }}
        className="text-lg font-bold text-secondary-900  sm:text-xl"
      >
        {title}
      </motion.h3>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.16 }}
          className="mt-2 max-w-md text-sm leading-relaxed text-secondary-600 "
        >
          {description}
        </motion.p>
      )}
      {action && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-6"
        >
          {action}
        </motion.div>
      )}
    </motion.div>
  );
}

export default EmptyState;
